import { validatorUrl } from "@/utils/rules.js";
export default {
  props: ["data", "isEdit", "isSee"],
  data() {
    return {
      loading: false,
      form: {
        isReprint: 1,
        zd: 0
      },
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { max: 255, message: "最多255 个字符", trigger: "blur" },
        ],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        sourceTitle: [
          { required: true, message: "请输入来源标题", trigger: "blur" },
        ],
        sourceUrl: [{ validator: validatorUrl, trigger: "blur" }],
        isReprint: [
          { required: true, message: "请选择是否转载", trigger: "change" },
        ],
        date: [
          {
            required: true,
            message: "请选择时间",
            trigger: "blur",
          },
        ],
        fbr: [
          { required: true, message: "发布人为必填字段", trigger: "blur"},
        ],
        // shr: [
        //   { required: true, message: "审核人为必填字段"},
        // ],
      },
    };
  },
  watch: {
    // isEdit(n) {
    //   if (n)
    //     this.init();
    // },
    "$attrs.visible"(n) {
      if (n) this.init();
    },
    data: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  watchEffect() {},
  mounted() {},
  methods: {
    init() {
      if (this.isEdit) {
        this.form = JSON.parse(JSON.stringify(this.data));
        setTimeout(() => {
          this.$refs["form"]?.validate();
        }, 0);
      } else {
        //对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
        this.$refs["form"].resetFields();
        this.form = {
          isReprint: 1,
        };
      }
      this.init2 && this.init2()
    },
    submit() {
      this.$refs["form"].validate((valid, key) => {
        if (valid) {
          this.loading = true;
          if (this.isEdit) {
            this.updateApi({
              ...this.form
            })
              .then(() => {
                this.$message.success("修改成功");
                this.$emit("update:visible", false);
                this.$emit("submit");
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            this.addApi(this.form)
              .then(() => {
                this.$message.success("添加成功");
                this.$emit("update:visible", false);
                this.$emit("submit");
                this.form = {};
              })
              .finally(() => {
                this.loading = false;
              });
          }
        } else {
          let errKey = Object.values(key)[0][0];
          let field = errKey.field;
          this.$message.warning(errKey.message);
          return false;
        }
      });
    },
    // 审核通过
    auditPass() {
      if (!this.form.id) {
        this.$message.warning("参数不完整，请刷新重试");
        return;
      }
      // if (!this.form.shr) {
      //   this.$message.warning("审核人为必填字段");
      //   return;
      // }
      this.auditApi({
        shr1: this.form.shr1,
        id: this.form.id,
        state: 1,
      })
        .then(() => {
          this.$alert('信息已发布', '提示', {
            confirmButtonText: '确定',
          }).then(()=>{
            this.$emit("update:visible", false);
            this.$emit("submit");
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 审核不通过
    auditReject() {
      if (!this.form.id) {
        this.$message.warning("参数不完整，请刷新重试");
        return;
      }
      // if (!this.form.shr) {
      //   this.$message.warning("审核人为必填字段");
      //   return;
      // }
      this.$prompt("请输入您的修改意见", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator(v){
          return v ? true : '请输入意见'
        }
      }).then(({ value }) => {
        if (!value) {
          this.$message.warning("请输入意见");
          return false;
        }
        this.auditApi({
          id: this.form.id,
          state: 2,
          suggestion:value
        })
          .then(() => {
            this.$message.success("修改成功");
            this.$emit("update:visible", false);
            this.$emit("submit");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
